export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'conversation_view_all',
  'conversation_view_assigned_self',
  'conversation_view_assigned_team',
  'conversation_view_participating',
  'conversation_view_unassigned',
  'conversation_respond',
  'conversation_manage_status',
  'conversation_assign_manage',
  'conversation_labels_manage',
  'conversation_custom_attributes_manage',
  'conversation_folders_manage',
  'conversation_delete',
  'contact_manage',
  'contact_view',
  'contact_create',
  'contact_edit',
  'contact_delete',
  'contact_import_export',
  'kanban_manage',
  'kanban_view_all',
  'kanban_view_assigned',
  'kanban_move_cards',
  'kanban_manage_pipelines',
  'legal_cases_manage',
  'legal_cases_view',
  'legal_cases_delete',
  'intimacoes_manage',
  'intimacoes_view',
  'intimacoes_link_client',
  'intimacoes_mark_read',
  'tarefas_manage',
  'tarefas_view_all',
  'tarefas_view_self',
  'tarefas_create',
  'tarefas_edit',
  'tarefas_complete',
  'tarefas_delete',
  'campaigns_manage',
  'campaigns_view',
  'campaigns_create',
  'follow_ups_manage',
  'follow_ups_view',
  'follow_ups_trigger_manual',
  'follow_ups_delete',
  'captain_manage',
  'captain_use',
  'report_manage',
  'reports_view_overview',
  'reports_view_agents',
  'reports_view_teams',
  'reports_view_labels',
  'reports_view_inboxes',
  'reports_view_csat',
  'knowledge_base_manage',
  'settings_inboxes_manage',
  'settings_agents_manage',
  'settings_teams_manage',
  'settings_custom_roles_manage',
  'settings_labels_manage',
  'settings_custom_attributes_manage',
  'settings_macros_canned_manage',
  'settings_automations_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';
export const CONVERSATION_UNASSIGNED_PERMISSIONS = 'conversation_unassigned_manage';
export const CONVERSATION_PARTICIPATING_PERMISSIONS = 'conversation_participating_manage';
export const CONTACT_PERMISSIONS = 'contact_manage';
export const REPORTS_PERMISSIONS = 'report_manage';
export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};

export const CUSTOM_ROLE_PERMISSION_CATEGORIES = [
  {
    key: 'conversations',
    icon: 'i-lucide-message-circle',
    title: 'Conversas & Atendimento',
    desc: 'Controle de visualização, resposta, atribuição e moderação de chats',
    permissions: [
      { key: 'conversation_view_all', isView: true },
      { key: 'conversation_view_assigned_self', isView: true },
      { key: 'conversation_view_assigned_team', isView: true },
      { key: 'conversation_view_participating', isView: true },
      { key: 'conversation_view_unassigned', isView: true },
      { key: 'conversation_respond', isEditor: true },
      { key: 'conversation_manage_status', isEditor: true },
      { key: 'conversation_assign_manage', isEditor: true },
      { key: 'conversation_labels_manage', isEditor: true },
      { key: 'conversation_custom_attributes_manage', isEditor: true },
      { key: 'conversation_folders_manage', isEditor: true },
      { key: 'conversation_delete', isDanger: true },
    ],
  },
  {
    key: 'contacts',
    icon: 'i-lucide-users',
    title: 'Contatos & CRM',
    desc: 'Acesso à base de clientes, cadastro, edição e exportação',
    permissions: [
      { key: 'contact_view', isView: true },
      { key: 'contact_create', isEditor: true },
      { key: 'contact_edit', isEditor: true },
      { key: 'contact_import_export', isEditor: true },
      { key: 'contact_delete', isDanger: true },
    ],
  },
  {
    key: 'kanban',
    icon: 'i-lucide-kanban',
    title: 'Kanban & Funis de Vendas/Atendimento',
    desc: 'Visualização de colunas, movimentação de cards e gestão de pipelines',
    permissions: [
      { key: 'kanban_view_all', isView: true },
      { key: 'kanban_view_assigned', isView: true },
      { key: 'kanban_move_cards', isEditor: true },
      { key: 'kanban_manage_pipelines', isEditor: true },
    ],
  },
  {
    key: 'legal_cases',
    icon: 'i-lucide-file-text',
    title: 'Processos Judiciais (Módulo Nativo)',
    desc: 'Acompanhamento processual vinculado aos contatos',
    permissions: [
      { key: 'legal_cases_view', isView: true },
      { key: 'legal_cases_manage', isEditor: true },
      { key: 'legal_cases_delete', isDanger: true },
    ],
  },
  {
    key: 'intimacoes',
    icon: 'i-lucide-scale',
    title: 'Intimações Judiciais (Módulo Nativo)',
    desc: 'Leitura de publicações nos diários oficiais e vinculação de prazos',
    permissions: [
      { key: 'intimacoes_view', isView: true },
      { key: 'intimacoes_link_client', isEditor: true },
      { key: 'intimacoes_mark_read', isEditor: true },
    ],
  },
  {
    key: 'tarefas',
    icon: 'i-lucide-check-square',
    title: 'Tarefas & Agenda de Prazos (Módulo Nativo)',
    desc: 'Gestão de prazos processuais e tarefas de toda a equipe',
    permissions: [
      { key: 'tarefas_view_all', isView: true },
      { key: 'tarefas_view_self', isView: true },
      { key: 'tarefas_create', isEditor: true },
      { key: 'tarefas_edit', isEditor: true },
      { key: 'tarefas_complete', isEditor: true },
      { key: 'tarefas_delete', isDanger: true },
    ],
  },
  {
    key: 'campaigns',
    icon: 'i-lucide-megaphone',
    title: 'Campanhas de WhatsApp (Motor Nativo)',
    desc: 'Disparos em massa com motor antibloqueio e templates A/B/C/D/E',
    permissions: [
      { key: 'campaigns_view', isView: true },
      { key: 'campaigns_create', isEditor: true },
      { key: 'campaigns_manage', isEditor: true },
    ],
  },
  {
    key: 'follow_ups',
    icon: 'i-lucide-repeat',
    title: 'Follow-up Inteligente com IA (Motor Nativo)',
    desc: 'Recuperação e reengajamento automático com OpenAI GPT-4o',
    permissions: [
      { key: 'follow_ups_view', isView: true },
      { key: 'follow_ups_trigger_manual', isEditor: true },
      { key: 'follow_ups_manage', isEditor: true },
      { key: 'follow_ups_delete', isDanger: true },
    ],
  },
  {
    key: 'captain',
    icon: 'i-lucide-sparkles',
    title: 'Capitão & Inteligência Artificial',
    desc: 'Assistente Copilot no atendimento e bases de conhecimento',
    permissions: [
      { key: 'captain_use', isEditor: true },
      { key: 'captain_manage', isEditor: true },
    ],
  },
  {
    key: 'reports',
    icon: 'i-lucide-trending-up',
    title: 'Relatórios & Analytics',
    desc: 'Métricas de tráfego, produtividade de agentes, times e CSAT',
    permissions: [
      { key: 'reports_view_overview', isView: true },
      { key: 'reports_view_agents', isView: true },
      { key: 'reports_view_teams', isView: true },
      { key: 'reports_view_labels', isView: true },
      { key: 'reports_view_inboxes', isView: true },
      { key: 'reports_view_csat', isView: true },
    ],
  },
  {
    key: 'settings',
    icon: 'i-lucide-settings',
    title: 'Configurações da Conta & Administração',
    desc: 'Gerenciamento estrutural de canais, agentes, tags e automações',
    permissions: [
      { key: 'settings_inboxes_manage', isEditor: true },
      { key: 'settings_agents_manage', isEditor: true },
      { key: 'settings_teams_manage', isEditor: true },
      { key: 'settings_custom_roles_manage', isEditor: true },
      { key: 'settings_labels_manage', isEditor: true },
      { key: 'settings_custom_attributes_manage', isEditor: true },
      { key: 'settings_macros_canned_manage', isEditor: true },
      { key: 'settings_automations_manage', isEditor: true },
    ],
  },
];

export const AVAILABLE_SIDEBAR_MENU_ITEMS = [
  { key: 'inbox_view', label: 'Caixa de Entrada', icon: 'i-lucide-inbox', desc: 'Notificações e fila de atendimento direto' },
  { key: 'conversations_index', label: 'Conversas', icon: 'i-lucide-message-circle', desc: 'Listagem e chat de conversas com clientes' },
  { key: 'kanban_index', label: 'Kanban', icon: 'i-lucide-kanban', desc: 'Quadros visuais de funis e pipelines' },
  { key: 'intimacoes_index', label: 'Intimações Judiciais', icon: 'i-lucide-scale', desc: 'Central de leitura e prazos de diários oficiais' },
  { key: 'tarefas_index', label: 'Tarefas & Prazos', icon: 'i-lucide-check-square', desc: 'Agenda, calendário e cumprimento de prazos' },
  { key: 'calls_index', label: 'Calls', icon: 'i-lucide-phone-call', desc: 'Histórico de ligações e chamadas' },
  { key: 'contacts_index', label: 'Contatos', icon: 'i-lucide-users', desc: 'Base de dados de contatos e clientes' },
  { key: 'campaigns_index', label: 'Campanhas WhatsApp', icon: 'i-lucide-megaphone', desc: 'Disparos em massa e campanhas ativas' },
  { key: 'follow_ups_index', label: 'Follow-up IA', icon: 'i-lucide-repeat', desc: 'Réguas e automação de recuperação de leads' },
  { key: 'captain_index', label: 'Capitão IA', icon: 'i-lucide-sparkles', desc: 'Assistente e bases de conhecimento com IA' },
  { key: 'reports_index', label: 'Relatórios', icon: 'i-lucide-trending-up', desc: 'Painéis de métricas e analytics de desempenho' },
  { key: 'settings_index', label: 'Configurações', icon: 'i-lucide-settings', desc: 'Menu de configurações e administração da conta' },
];
